import {
    LoginDataFormValues,
    ForgottenPasswordDataFormValues,
    LoginOtpDataFormValues,
} from './types';

export const loginDataKeys: { [K in keyof LoginDataFormValues]: K } = {
    email: 'email',
    password: 'password',
};

export const forgottenPasswordDataKeys: { [K in keyof ForgottenPasswordDataFormValues]: K } = {
    email: 'email',
    password: 'password',
};

export const loginOtpDataKeys: { [K in keyof LoginOtpDataFormValues]: K } = {
    email: 'email',
    token: 'token',
};
